import React from "react";
import PartnersContainer from "../../containers/partners/index";
import PartnerContainer from "../../containers/partners/Partner";
import { useParams } from "react-router-dom";

const PartnersPage = () => {
  let { id } = useParams();

  return id ? <PartnerContainer id={id} /> : <PartnersContainer />;
};

export default PartnersPage;
